import { ConnectionHandler, type RecordSourceSelectorProxy, type RecordProxy } from 'relay-runtime';
import RelayDataID from '@atlassian/relay-data-id';
import {
	GRAPHQL_FIELD_AGS_RELATIONSHIP_PROJECTS,
	GRAPHQL_FIELD_GRAPH_STORE,
	GRAPHQL_TYPE_JIRA_AVATAR,
	GRAPHQL_TYPE_JIRA_PROJECT,
} from '../../../common/constant';

export const updateStore = (
	store: RecordSourceSelectorProxy,
	deletedProjectAris: string[],
	currentProjectAri: string,
) => {
	const graphStoreRecord: RecordProxy = store.getRoot().getLinkedRecord(GRAPHQL_FIELD_GRAPH_STORE);

	if (!graphStoreRecord) {
		return;
	}

	const connection: RecordProxy = graphStoreRecord.getLinkedRecord(
		GRAPHQL_FIELD_AGS_RELATIONSHIP_PROJECTS,
		{
			id: currentProjectAri,
		},
	);

	if (!connection) {
		return;
	}

	deletedProjectAris.forEach((toProjectAri) => {
		const deletedProjectNodeId = RelayDataID({ id: toProjectAri }, GRAPHQL_TYPE_JIRA_PROJECT);
		const deletedAvatarNodeId = RelayDataID({ id: toProjectAri }, GRAPHQL_TYPE_JIRA_AVATAR);

		if (deletedProjectNodeId && deletedAvatarNodeId) {
			ConnectionHandler.deleteNode(connection, deletedProjectNodeId);
			ConnectionHandler.deleteNode(connection, deletedAvatarNodeId);
			store.delete(deletedProjectNodeId);
			store.delete(deletedAvatarNodeId);
		}
	});
};
